export default "__VITE_ASSET__Bh5jQj6N__"